import type { FC } from "react";
import { defaultColor } from "../constants";
import type { IconProps } from "./types";
export const Settings: FC<IconProps> = ({
  color = defaultColor,
  height = 24,
}) => (
  <svg
    width="25"
    height={height}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.7443 5.42446C11.1782 3.52518 13.8218 3.52518 14.2557 5.42446C14.4292 6.18409 15.2775 6.54948 15.9279 6.14336L16.0842 6.04582C17.6757 5.05204 19.4745 6.96396 18.4542 8.56162C18.0373 9.21434 18.3874 10.0936 19.1314 10.2598C20.9562 10.6674 20.9562 13.3326 19.1314 13.7402C18.3874 13.9064 18.0373 14.7857 18.4542 15.4384C19.4745 17.036 17.6757 18.948 16.0842 17.9542L15.9279 17.8566C15.2775 17.4505 14.4292 17.8159 14.2557 18.5755C13.8218 20.4748 11.1782 20.4748 10.7443 18.5755C10.5708 17.8159 9.72248 17.4505 9.07206 17.8566L8.91584 17.9542C7.32427 18.948 5.52551 17.036 6.54582 15.4384C6.96266 14.7857 6.61264 13.9064 5.86857 13.7402C4.04381 13.3326 4.04381 10.6674 5.86856 10.2598C6.61264 10.0936 6.96266 9.21434 6.54582 8.56162C5.52551 6.96396 7.32427 5.05204 8.91584 6.04581L9.07206 6.14336C9.72248 6.54948 10.5708 6.18409 10.7443 5.42446ZM12.5 14.9807C14.1462 14.9807 15.4807 13.6462 15.4807 12C15.4807 10.3538 14.1462 9.01932 12.5 9.01932C10.8538 9.01932 9.51933 10.3538 9.51933 12C9.51933 13.6462 10.8538 14.9807 12.5 14.9807Z"
      fill={color}
    />
  </svg>
);
